import Modal from '../ui/Modal'
import Button from '../ui/Button'

export default function EditScopeDialog({ open, onClose, onChoose, actionLabel = 'Edit' }) {
    return (
        <Modal open={open} onClose={onClose} title={`${actionLabel} recurring event`} maxWidth="max-w-sm">
            <div className="p-4 space-y-2">
                <p className="mb-3 font-mono text-xs text-zinc-500">This event is part of a series. Which events should this apply to?</p>
                <Button className="w-full justify-start" variant="secondary" onClick={() => onChoose('this')}>This event</Button>
                <Button className="w-full justify-start" variant="secondary" onClick={() => onChoose('following')}>This and following events</Button>
                <Button className="w-full justify-start" variant="secondary" onClick={() => onChoose('all')}>All events</Button>
                <Button className="w-full justify-start mt-3" variant="ghost" onClick={onClose}>Cancel</Button>
            </div>
        </Modal>
    )
}
